var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#00A096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0242 5.00439C12.3082 5.23877 12.3484 5.65896 12.114 5.94291L7.71186 11.2762C7.59075 11.423 7.41272 11.511 7.22259 11.5181C7.03247 11.5252 6.84837 11.4507 6.71665 11.3134L4.00766 8.48989C3.75275 8.22421 3.76149 7.80219 4.02717 7.54728C4.29285 7.29238 4.71487 7.30111 4.96978 7.56679L7.16029 9.84992L11.0857 5.09416C11.3201 4.8102 11.7402 4.77001 12.0242 5.00439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/checkmarkFilled.004d4a94bbd10a52c46cabef07e2d0fe.svg";
export { ForwardRef as ReactComponent };